import GlobalStore from '../../stores/GlobalStore/GlobalStore'
import NotificationStore from '../../stores/NotificationStore/NotificationStore'
import { Interceptor } from '../FetchService'

function createErrorInterceptor(
  globalStore: GlobalStore,
  notificationStore: NotificationStore
): Interceptor {
  return (next) => async (request: Request) => {
    try {
      const response: Response = await next(request)
      if (!response.ok) {
        const data = await response.text()

        if (response.status === 401) {
          globalStore.clearUserAndRouteToLogin()

          notificationStore.sendNotification(
            '401',
            data === '' ? 'Session has ended. Please login.' : data,
            { variant: 'error' },
            undefined,
            30000
          )
        } else if (data === '') {
          notificationStore.sendNotification(
            response.url,
            'An error has occurred: ' + response.statusText,
            { variant: 'error' },
            undefined,
            30000
          )
        } else {
          try {
            const parsedData = JSON.parse(data)
            const errorMessage =
              parsedData?.message ||
              (typeof parsedData === 'string' ? parsedData : 'An error has occurred')
            notificationStore.sendNotification(
              response.url,
              errorMessage,
              { variant: 'error' },
              undefined,
              30000
            )
          } catch {
            notificationStore.sendNotification(response.url, data, {
              variant: 'error',
            })
          }
        }
        return Promise.reject(response)
      }
      return response
    } catch (error) {
      // Handle network failures (e.g., "Failed to fetch")
      const errorMessage =
        error instanceof Error ? error.message : 'Network error occurred'
      notificationStore.sendNotification(
        request.url,
        'An error has occurred: ' + errorMessage,
        { variant: 'error' },
        undefined,
        30000
      )
      return Promise.reject(error)
    }
  }
}

export default createErrorInterceptor
